import { reactive, computed } from 'vue';
import type { Role, SessionUser } from '@mbs/shared';
import { api } from './api';

const state = reactive<{ user: SessionUser | null; loaded: boolean }>({
  user: null,
  loaded: false,
});

export const session = {
  state,
  user: computed(() => state.user),
  isAuthenticated: computed(() => Boolean(state.user)),

  /** Admin implies every role, matching the Worker. */
  can(...roles: Role[]): boolean {
    const user = state.user;
    if (!user) return false;
    if (user.roles.includes('admin')) return true;
    return roles.some((r) => user.roles.includes(r));
  },

  async load(): Promise<SessionUser | null> {
    try {
      const result = await api.get<{ user: SessionUser | null }>('/api/auth/me');
      state.user = result.user;
    } catch {
      // A failed /me on a cold, offline start must not block the app shell.
      state.user = null;
    }
    state.loaded = true;
    return state.user;
  },

  async login(userId: string, password: string): Promise<SessionUser> {
    const result = await api.post<{ user: SessionUser }>('/api/auth/login', {
      user_id: userId,
      password,
    });
    state.user = result.user;
    state.loaded = true;
    return result.user;
  },

  async logout(): Promise<void> {
    try {
      await api.post('/api/auth/logout');
    } finally {
      state.user = null;
    }
  },
};
